export default __webpack_public_path__ + "static/mainProject2-e7d8477bd3a8994eaae090ac347c8081.png";